<template>
  <div v-if="isDecktop" class="tm-order tm-order-check tm-pro-order-check">
    <preloader :is-visible="isLoading"></preloader>
    <ProRetouchersInactivityTimer
        v-if="downtime !== null"
        :downtime="downtime"
        :new_orders_count="new_orders_count"
        @is-loading="isLoading = $event"
        @retry="fetchDowntime"></ProRetouchersInactivityTimer>
    <md-card class="uk-margin-remove-top" v-else-if="empty_order === ''">
      <div class="uk-padding-xsmall">
        <div class="uk-grid uk-grid-small uk-margin tm-senior-retoucher" data-uk-grid>
          <!--левая часть-->
          <ProRetouchersMainPhotoBlock
              v-if="creteMainPhotoBlock"
              :main_photo_block="main_photo_block"
              :with-faces-visible="withFacesVisible"
              :zone-visible="zoneVisible"
              :order_number="order_number"
              :zone_photo="zone_photo"
              :afterVisible="afterVisible"
              @is-loading="isLoading = $event"
              @retry="reLoadPage"
          ></ProRetouchersMainPhotoBlock>
          <div class="uk-width-1-4 4">
            <!--правая часть-->
            <order-card-head
                :education="isEducation"
                :order_number="order_number"
                :new_orders_count="parentNewOrdersCount"
                :main_photo_before_with_faces="main_photo_before_with_faces"
                @visible="withFacesVisible = $event"
                @visible-after="afterVisible = $event"
                @auto_order_check="auto_order_check = $event"
                :role="'pro-retoucher'"
            ></order-card-head>
            <ProRetouchersInfoBlock
                v-if="createInfoBlock"
                :order_id="order_id"
                :main_photo_before_with_faces="main_photo_before_with_faces"
                :how_much_orders="how_much_orders"
                :prev_status_order="prev_status_order"
                @zone-visible="zoneVisible = $event"
                @after-visible="afterVisible = $event"
                @zone_photo="zone_photo = $event"
                @loading="infoloading = $event"
                @order_cost_credits="cost = $event"
                @faces="faces = $event"
                @with-faces-visible="withFacesVisible = $event"
                :permission="statusesForEditingOfFunctions.includes(prev_status_order) ? null : 'read'"
            ></ProRetouchersInfoBlock>
            <div v-if="junior_order" class="uk-margin-small uk-label uk-label-warning uk-display-block uk-text-center">
              NEWBIE
            </div>
            <ChatBlock
                :infoloading="infoloading"
                v-if="order_chat !== '' && user"
                :order_chat="!Array.isArray(order_chat) ? Object.values(order_chat) : order_chat"
                :faces="faces"
                :order_id="Number (order_id)"
                :user="user.email"
                :role="user.role"
                @zone-visible="zoneVisible = $event"
                @after-visible="afterVisible = $event"
                @zone_photo="zone_photo = $event"
                @loading="infoloading = $event"
            ></ChatBlock>
            <ActivitiesOfProRetoucher v-if="createButtonsBlock" :local_page_keys="local_page_keys"
                                      :loading="infoloading" :faces="faces"
                                      :order_id="order_id" :main_photo_after="main_photo_after"
                                      :main_photo_before="main_photo_before"
                                      :canvasWidth="canvasWidth" :canvasHeight="canvasHeight"
                                      :prev_status_order="prev_status_order"
                                      :order_number="order_number" :cost="cost" :junior_order="junior_order"
                                      :role="role" @isLoading="isLoading = $event"
                                      :auto_order_check="auto_order_check"
                                      :showCompleteOrderButton="showCompleteOrderButton"
                                      :education="isEducation"
                                      @reload="reLoadPage"
            ></ActivitiesOfProRetoucher>
          </div>
        </div>
        <hr class="uk-margin-medium">
        <h4 class="uk-margin">{{ local_page_keys.title_previous_orders }}:</h4>
        <prev-orders-block v-if="createPrevBlock"
                           :currRole="'pro-retoucher'"></prev-orders-block>
      </div>
    </md-card>
  </div>
</template>

<script>
import Preloader from "@/pages/Dashboard/Components/Preloader";
import PrevOrdersBlock from "@/pages/Dashboard/Components/PrevOrdersBlock";
import OrderCardHead from "@/pages/Dashboard/Components/OrderCardHead";
import ProRetouchersMainPhotoBlock from "@/pages/Dashboard/Components/for_pro_retouchers/ProRetouchersMainPhotoBlock";
import ProRetouchersInfoBlock from "@/pages/Dashboard/Components/for_pro_retouchers/ProRetouchersInfoBlock";
import ProRetouchersInactivityTimer from "@/pages/Dashboard/Components/for_pro_retouchers/ProRetouchersInactivityTimer";
import ActivitiesOfProRetoucher from "@/pages/Dashboard/Components/for_pro_retouchers/ActivitiesOfProRetoucher";
import ChatBlock from "@/pages/Dashboard/Components/ChatBlock";

export default {
  name: 'ProRetouchersOrderEducationCheck',
  data: () => ({
    createButtonsBlock: false,
    infoloading: true,
    createdowntime: false,
    createPrevBlock: false,
    createHistoryBlock: false,
    creteMainPhotoBlock: false,
    createInfoBlock: false,
    main_photo_block: null,
    main_photo_before_with_faces: null,
    afterVisible: true,
    downtime: null,
    withFacesVisible: false,
    zoneVisible: false,
    zone_photo: null,
    modal_photo: null,
    orderStatus: '',
    empty_order: '',
    isLoading: true,
    order_number: '',
    education: null,
    order_id: '',
    modal_photo_before_with_faces: '',
    faces: [],
    local_page_keys: {},
    order_chat: '',
    my_email: '',
    cost: 0,
    junior_order: false,
    main_photo_after: null,
    main_photo_before: null,
    canvasWidth: 560,
    canvasHeight: 360,
    prev_status_order: null,
    how_much_orders: null,
    role: '',
    new_orders_count: 0,
    intervalNewOrders: null,
    is_orders_to_work: true,
    user: '',
    auto_order_check: null,
    statusesForEditingOfFunctions: ['hold-admin-new', 're-done-customer'],
    getterKey:0,
  }),
  components: {
    PrevOrdersBlock,
    Preloader,
    ChatBlock,
    OrderCardHead,
    ProRetouchersMainPhotoBlock,
    ProRetouchersInfoBlock,
    ProRetouchersInactivityTimer,
    ActivitiesOfProRetoucher
  },
  methods: {
    async fetchMainPhotoBlock() {
      try {
        let data = null;
        if (this.role === 'test-retoucher') {
          await this.$store.dispatch("order/mainPhotoBlockForRetoucher", 'pro-retoucher');
        } else {
          await this.$store.dispatch("order/mainPhotoBlockForRetoucher");
        }
        data = await this.$store.getters['order/mainPhotoBlock'];
        if (data) {

          if (typeof (data) !== 'string') {
            this.main_photo_before_with_faces = process.env.VUE_APP_API_BASE_URL.replace('api/v1', '') + data.main_photo_before_with_faces;
            this.order_number = data.order_number;
            this.order_id = data.order_id;
            this.education = data.education;
            this.junior_order = data.test_order
            await this.fetchChatBlock();
            this.main_photo_block = data;
            this.creteMainPhotoBlock = true;
            this.createInfoBlock = true;
            this.createHistoryBlock = true;
            this.createPrevBlock = true;
            setTimeout(() => {
              this.createButtonsBlock = true;
            }, 2000)
            this.isLoading = false;
            this.prev_status_order = data.prev_status_order;
            this.how_much_orders = data.how_much_orders;
            if (Object.keys(data).includes('main_photo_after')) {
              this.main_photo_after = data.main_photo_after;
              this.canvasWidth = data.main_photo_after_width;
              this.canvasHeight = data.main_photo_after_height;
              this.main_photo_before = process.env.VUE_APP_API_BASE_URL.replace('api/v1', '') + data.main_photo_before;
            } else {
              this.main_photo_before = data.main_photo_before;
              this.canvasWidth = data.main_photo_before_width;
              this.canvasHeight = data.main_photo_before_height;
            }

          } else {
            this.isLoading = false;
            this.empty_order = data;
            this.createdowntime = true;
          }
        } else {
          this.errors = this.local_page_keys.alert_failed_main_photo_block;
        }
      } catch (e) {
        alert(e);
      }
    },

    /**
     * Method for get data of unclosed downtime and availability of new orders in the queue
     * from DowntimeController (method index)
     * identifiable data: isLoading - define as false
     *                    orderStatus - type: string - if there is unclosed downtime defined as 'done'
     **/
    async fetchDowntime() {
      try {
        let data = null;
        await this.$store.dispatch("order/downtimeProRetoucher", {education: 'education'});
        data = await this.$store.getters['order/downtimeProRetoucher'];
        if (data) {
          this.new_orders_count = data.new_orders_count;
          this.$nextTick(() => {
            this.new_orders_count = data.new_orders_count;
          });
          if (data.order_in_work === true) {
            this.isLoading = false;
            this.downtime = null;
            await this.fetchMainPhotoBlock();
          } else {
            this.isLoading = false;
            this.downtime = data;
            if (!this.is_orders_to_work && data.is_orders_to_work) {
              let audio = new Audio('/audio/juntos-607.mp3');
              audio.play();
              this.is_orders_to_work = data.is_orders_to_work;
            } else {
              this.is_orders_to_work = data.is_orders_to_work;
            }
          }
        } else {
          this.errors = this.local_page_keys.alert_failed_downtime;
        }
      } catch (e) {
        alert(e);
      }
    },

    async fetchChatBlock() {
      try {
        let data;
        await this.$store.dispatch("order/historyBlock", this.order_id);
        data = await this.$store.getters["order/historyBlock"];
        if (data.status === 'ok') {
          this.order_chat = data.chat !== '' ? JSON.parse(data.chat) : '';
        } else {
          this.errors = this.local_page_keys.alert_failed_historyBlock;
          this.loading = false;
        }
      } catch (e) {
        alert(e);
      }
    },
    reLoadPage() {
      this.order_chat = '';
      this.isLoading = true;
      this.main_photo_before = null;
      this.main_photo_after = null;
      this.creteMainPhotoBlock = false;
      this.createInfoBlock = false;
      this.createPrevBlock = false;
      this.createButtonsBlock = false;
      this.order_chat = '';
      this.junior_order = false;
      this.fetchDowntime();
    },
    async fetchCountNewOrders () {
      let data;
      await this.$store.dispatch('order/countNewOrdersPro');
      data = await this.$store.getters['order/countNewOrdersPro'];
      this.new_orders_count = data.new_orders_count ? data.new_orders_count : 0;
    },
  },

  computed: {
    isEducation(){
      return this.education;
    },
    parentNewOrdersCount(){
      return this.new_orders_count;
    },
    showCompleteOrderButton() {
      if (this.role !== 'pro-retoucher')
        return  true;
       if (this.order_chat) {
         const searchString = "redo client";
         const limit = 3;
         const count = this.order_chat.filter(item => item.name === searchString).length;
         return count > limit;
       }
      return false;
    },
    isDecktop(){
      //return !(window.matchMedia("(any-pointer:coarse)").matches &&  window.innerWidth <= 1180);
      const navigatorAgent =
          navigator.userAgent || navigator.vendor || window.opera;
      return !(
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series([46])0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
              navigatorAgent
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br([ev])w|bumb|bw-([nu])|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do([cp])o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly([-_])|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-([mpt])|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c([- _agpst])|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac([ \-/])|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja([tv])a|jbro|jemu|jigs|kddi|keji|kgt([ /])|klon|kpt |kwc-|kyo([ck])|le(no|xi)|lg( g|\/([klu])|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t([- ov])|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30([02])|n50([025])|n7(0([01])|10)|ne(([cm])-|on|tf|wf|wg|wt)|nok([6i])|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan([adt])|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c([-01])|47|mc|nd|ri)|sgh-|shar|sie([-m])|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel([im])|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c([- ])|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(
              navigatorAgent.substr(0, 4)
          )
      );
    }
  },
  async created() {
    this.local_page_keys = await this.$filtergetLocalisationPage('order-orderCheck');
    this.role = await this.$store.getters['profile/role'];
    await this.$store.dispatch('profile/me');
    this.getterKey++;
    this.user = await this.$store.getters['profile/me'](this.getterKey);
    await this.fetchDowntime();
    if(typeof this.new_orders_count == 'undefined'){
      await this.fetchCountNewOrders();
      if (this.role === 'pro-retoucher') {
        this.intervalNewOrders = setInterval(() => {
          this.fetchCountNewOrders();
        }, 10000);
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.intervalNewOrders);
  }
}
</script>
<style>
/*Layout*/
@import '../../../assets/css/uikit/grid.css';
/*Utilities*/
@import '../../../assets/css/uikit/background.css';
@import '../../../assets/css/uikit/label.css';
@import '../../../assets/css/uikit/width.css';
@import '../../../assets/css/uikit/height.css';
@import '../../../assets/css/uikit/flex.css';
@import '../../../assets/css/uikit/margin.css';
@import '../../../assets/css/uikit/padding.css';
@import '../../../assets/css/uikit/position.css';
@import '../../../assets/css/uikit/utility.css';
@import '../../../assets/css/uikit/transition.css';
@import '../../../assets/css/uikit/text.css';
@import '../../../assets/css/uikit/overlay.css';
@import '../../../assets/css/uikit/animation.css';
@import '../../../assets/css/custom.css';

.tm-file-name {
  word-break: break-all;
  line-height: 1;
}

.prev-img {
  width: 60px;
  height: 60px;
  background-color: #ccc
}

#files-area {
  border-radius: 6px;
  border: 3px dashed #e8e8e8;
  background-color: #f5f5f5;
  min-height: 100px;
}

.file-block {
  overflow: hidden;
  border-radius: 6px;
  background-color: rgba(144, 163, 203, 0.2);
  margin: 5px 0;
}

.tm-file-delete {
  cursor: pointer;
  padding: 10px;
}

/*.tm-button-add {*/
/*  padding: 0 9px;*/
/*  border-radius: 50px;*/
/*}*/

.main-photo-dialog {
  height: 100%;
}

.left-part-main-photo {
  width: 100%;
}

.buttons {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.comments-button {
  border: #297a96 2px solid;
  border-radius: 5px;
  width: 75%;
  height: 90%;
  background: none;
  color: #3e3d3d;
  margin: 2px;
}

.scrollable-dialog {
  max-height: 80% !important;
  overflow-y: auto;
}

.checkFunctions {
  display: contents;
}

.image-compare-handle {
  color: #f10404;
  background-color: currentColor;
  cursor: ew-resize;
  transform: translateX(-50%) translateZ(0);
  width: 2px;
  z-index: 2;
  will-change: left;

}

/*.tm-block-img {*/
/*  background-color: #f0f0f0;*/
/*  width: 550px;*/
/*  height: 550px;*/
/*  display: -webkit-box;*/
/*  display: -ms-flexbox;*/
/*  display: flex;*/
/*  -webkit-box-align: center;*/
/*  -ms-flex-align: center;*/
/*  align-items: center;*/
/*  -webkit-box-pack: center;*/
/*  -ms-flex-pack: center;*/
/*  justify-content: center;*/
/*}*/

/*.tm-order-check .tm-block-img img {*/
/*  height: 100%;*/
/*  object-fit: contain;*/
/*}*/

/*.main-photo-image {*/
/*  min-width: 550px;*/
/*}*/

.display {
  display: none;
}

.cancel-order {
  margin: auto;
}

</style>